export const GRAPHQL_VARIABLES = {
  filter: {
    _id: '5fc44c3584ffd06759c1a1e5'
  }
};

export const QUERY = `
  mutation customersRemove ($filter: AutoFilledFilterRemoveOnecustomersInput!, $sort: SortRemoveOnecustomersInput) {
    customersRemove (filter: $filter, sort: $sort) {
        recordId
        record {
            email
            phone
            firstName
            lastName
            companyName
            address {
                address1
                address2
                address3
                state
                city
                zip
                country
                _id
            }
            companyId
            bkUser
            bkCompany
            _id
            updatedAt
            createdAt
        }
        error {
            message
        }
    }
  }
`;
